// extracted by mini-css-extract-plugin
export default {"content":"NotFound_content__ovy5e","illustration":"NotFound_illustration__wKR5d","illustrationText":"NotFound_illustrationText__93Azt"};